import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import Footer from "components/templates/Footer";
import MobileAppNav from "components/templates/MobileAppNav";
import { initWebviewConfig, type WebviewConfig } from "utils/webviewConfig.util";

/**
 * Re-sync embed / platform flags when the URL changes (e.g. payment return
 * without embed=1). Without this, App would keep a one-shot false from mount
 * and the bottom nav would never come back after checkout.
 */
export default function PartnerAppChrome() {
  const location = useLocation();
  const [webviewConfig, setWebviewConfig] = useState<WebviewConfig>(() =>
    initWebviewConfig()
  );

  useEffect(() => {
    setWebviewConfig(initWebviewConfig());
  }, [location.pathname, location.search]);

  const showNav = webviewConfig.embed || webviewConfig.platformApp;

  return (
    <>
      {showNav && (
        <ErrorBoundary>
          <MobileAppNav />
        </ErrorBoundary>
      )}
      {webviewConfig.showFooter && (
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
      )}
    </>
  );
}
